var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 152,
    height: 81,
    viewBox: "0 0 152 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M118.243 46.6348H83.5659V52.6457H118.243V46.6348Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M117.793 38.4199L100.78 21.3889L83.7661 38.4199L88.1196 42.7778L88.3698 43.0283L100.78 30.5556L113.239 43.0283L117.793 38.4199Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M72.6073 22.8416V34.3625H66.7026V40.3734H72.6073V55H79.1124V22.8416H72.6073Z",
    fill: "#EE853A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1364 44.0301H52.5915V28.8525H67.6034V22.8416H42.0332V28.8525H46.1364V44.0301Z",
    fill: "#EE853A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M63.5502 31.0063H57.0951V46.6348H42.0332V52.6457H68.5541V46.6348H63.5502V31.0063Z",
    fill: "#EE853A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3667 22.8416V47.5365H27.8218V28.8525H37.8297V22.8416H21.3667Z",
    fill: "#EE853A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0 22.8416V28.8525H9.95786V40.1731H16.463V22.8416H0Z",
    fill: "#EE853A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6266 14.7268L18.915 0L4.15332 14.7268L8.75695 19.3352L18.915 9.16667L29.073 19.3352L33.6266 14.7268Z",
    fill: "#EE853A"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M152 45H123V51H152V45Z",
    fill: "black"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 126,
    y: 55,
    width: 21,
    height: 6,
    fill: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 126,
    y: 65,
    width: 21,
    height: 6,
    fill: "black"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 148,
    y: 55,
    width: 16,
    height: 6,
    transform: "rotate(90 148 55)",
    fill: "black"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 132,
    y: 65,
    width: 16,
    height: 6,
    transform: "rotate(90 132 65)",
    fill: "black"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 126,
    y: 75,
    width: 22,
    height: 6,
    fill: "black"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 134,
    y: 45,
    width: 6.5,
    height: 11,
    fill: "black"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 127,
    y: 23,
    width: 21,
    height: 6,
    fill: "black"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 127,
    y: 33,
    width: 21,
    height: 6,
    fill: "black"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 148,
    y: 23,
    width: 20,
    height: 7,
    transform: "rotate(90 148 23)",
    fill: "black"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.a75b4038b20202966b65dc3f8bce3e93.svg";
export { ForwardRef as ReactComponent };